export const VERSION = 'dev-master#14cfa68';
